import axios from 'axios';
import { IUser } from '../contracts/user.contract';
import ConfigService from './config.service';
import { PublicClientApplication, AccountInfo } from '@azure/msal-browser';

const getCurrentUser = async (): Promise<IUser> => {
    const res = await axios.get(`${ConfigService.appConfig.baseApiUrl}/User/Currentuser`);
    return res.data;
};

const getAuthToken = async (instance: PublicClientApplication, account: AccountInfo) => {
    const accountScopes = sessionStorage.getItem('isInternal') === 'true' ? ConfigService.azureADScope.scopes : ConfigService.azureB2CScope.scopes;

    const tokenResponse = await instance.acquireTokenSilent({ scopes: accountScopes, account: account });
    return tokenResponse.accessToken;
};

const UserService = {
    getCurrentUser,
    getAuthToken
};

export default UserService;
